import { Platform } from "src/libs/platform";
import { Log } from "src/libs/log";
import { Token } from "src/containers/authentication/models/token";

declare global {
    interface Window {
        MobileLogout: MessagePort;
        MobileBiometrics: MessagePort;
        MobileRefreshToken: MessagePort;
        MobileInAppWebsite: MessagePort;
        flutter_inappwebview: {
            _callHandler: (name: string) => Promise<any>;
        };
    }
}

class MobileUtils {
    static getB2CToken = () => {
        const queryString = window.location.search.substring(1);
        return new URLSearchParams(queryString).get("code");
    };

    static getTokenFromUrl = (): Token | null => {
        const queryString = window.location.hash.substring(1);
        const tokenString = new URLSearchParams(queryString).get("webtoken");
        if (tokenString !== null) {
            const json = JSON.parse(decodeURIComponent(tokenString));
            return Token.fromJson<Token>(json);
        }
        return null;
    };

    static logoutMobile = () => {
        if (Platform.isRunningOnFlutter()) {
            try {
                const postMessageOrigin = window.MobileLogout;
                if (postMessageOrigin) {
                    postMessageOrigin.postMessage("logout");
                }
                if (window.flutter_inappwebview) {
                    window.flutter_inappwebview
                        ._callHandler("MobileLogout")
                        .then(() => {
                            Log.info("Login out...");
                        });
                }
            } catch (e) {
                Log.error("error in WebviewChannel.logout:", e);
            }
        }
    };

    static launchBiometrics = () => {
        if (Platform.isRunningOnFlutter()) {
            try {
                const postMessageOrigin = window.MobileBiometrics;
                postMessageOrigin.postMessage("biometrics");
            } catch (e) {
                Log.error("error in WebviewChannel.biometrics:", e);
            }
        }
    };

    static refreshToken = (token: Token) => {
        if (Platform.isRunningOnFlutter()) {
            try {
                const tokenString = JSON.stringify(token);

                const postMessageOrigin = window.MobileRefreshToken;
                postMessageOrigin.postMessage(tokenString);
            } catch (error) {
                Log.error("Error dispatching MobileRefreshToken event:", error);
            }
        }
    };
}

export { MobileUtils };
